import React from "react";
import ReactDOM from "react-dom/client";
import AppV2 from "./pages/AppV2";
import { BrowserRouter } from "react-router-dom";
import './styles/index.css'

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppV2 />
    </BrowserRouter>
  </React.StrictMode>
);
